import React__default from 'react';
import clsx from 'clsx';

const ProgressBar = ({ progress = 1, className }) => {
    const style = {
        width: `${progress}%`
    };
    return (React__default.createElement("div", { "data-testid": 'progress-bar', className: clsx('c-uploader__progress-bar', className) },
        React__default.createElement("div", { style: style, className: 'c-uploader__progress-bar-indicator' })));
};

export { ProgressBar as default };
//# sourceMappingURL=ProgressBar.js.map
